import {
  SET_CATEGORIES_ERROR,
  SET_CATEGORIES_LOADING,
  SET_CATEGORIES,
  SET_MATERIAL_CATEGORIES,
  SET_PRODUCT_CATEGORIES,
} from "../../actions/categoryAction";

const initialState = {
  datas: null,
  productDatas: null,
  materialDatas: null,
  loading: false,
  error: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCT_CATEGORIES:
      return { ...state, productDatas: action.data, error: null };
    case SET_MATERIAL_CATEGORIES:
      return { ...state, materialDatas: action.data, error: null };
    case SET_CATEGORIES:
      return { ...state, datas: action.data, error: null };
    case SET_CATEGORIES_LOADING:
      return { ...state, loading: action.status };
    case SET_CATEGORIES_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default categoryReducer;
